import { v4 } from 'uuid';

import { BLUEPRINT_SCHEMA_VERSION } from '../public.constants';
import { BlueprintContext } from '../blueprint-context/blueprint-context.class';
import { RecordData } from '../../helpers-classes';
import { SchemaUpdate } from '../../schema-update-classes';

import { BlueprintData, BlueprintDataIn } from './types';

export const blueprintData = (context: BlueprintContext, dataRawIn: BlueprintDataIn = null): BlueprintData => {
	// const { userEmail } = context;
	let dataIn: BlueprintDataIn = dataRawIn;

	// update blueprint schema data if a newer version is available (skip for brand-new blueprints with no schema)
	if (dataRawIn?.schemaVersion != null && dataRawIn.schemaVersion !== BLUEPRINT_SCHEMA_VERSION) {
		const schemaUpdate = new SchemaUpdate(dataIn);
		dataIn = schemaUpdate.bpData;
	}

	const rd = new RecordData<BlueprintDataIn>(dataIn);

	const record: BlueprintData = {
		id: rd.useNewOrPartial<string>('id', v4()),
		email: rd.useNew<string>('email', dataRawIn.email, { notEmpty: true }),
		schemaVersion: rd.useNew<number>('schemaVersion', BLUEPRINT_SCHEMA_VERSION, { defaultValue: null }),
		submissionDate: rd.useNewOrDefault<string>('submissionDate', Date.now().toString()),
		submissionId: rd.useNewOrDefault<string | null>('submissionId', null),
		thumbnail: rd.useNewOrDefault<string>('thumbnail', ''),
		metadata: dataIn?.metadata ?? null,
		kitchens: dataIn?.kitchens ?? null
	};

	return record;
};

